module.exports = __webpack_public_path__ + "static/media/darth-vader.11b48ce4.png";